import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

export const VerticalSeparator = ({ className }) => {
  return (
    <div
      data-testid="vertical-separator"
      className={classnames("tw-w-px tw-h-10 tw-bg-theme-400", className)}
    />
  );
};

VerticalSeparator.propTypes = {
  className: PropTypes.string,
};
